import React from "react";
import {
  Datagrid,
  Filter,
  List,
  SearchInput,
  ReferenceField,
  ListProps,
  FunctionField,
  TextField,
} from "react-admin";
import { Helmet } from "react-helmet";
import { Typography } from "@material-ui/core";
import moment from "moment";
import { SchoolIdSelected } from "utils/tools";

const NotTakingFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const NotTakingList = (props: ListProps) => {
  return (
    <>
      <Helmet>
        <title>Not Taking Students</title>
      </Helmet>
      <List
        exporter={false}
        filters={<NotTakingFilter />}
        bulkActionButtons={false}
        {...props}
      >
        <Datagrid rowClick="edit">
          <TextField source="id" />
          <ReferenceField
            label="Route Plan Wave"
            source="busSchedulePlanId"
            reference="busSchedulePlans"
            link={false}
          >
            <ReferenceField
              source="busScheduleId"
              reference="busSchedules"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </ReferenceField>
          <ReferenceField
            label="Route"
            source="routeId"
            reference="routes"
            linkType={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField
            label="Student"
            source="studentId"
            reference="students"
            linkType="show"
          >
            <FunctionField
              render={(record: any) => `${record.firstName} ${record.lastName}`}
            />
          </ReferenceField>
          <FunctionField
            label="Not Taking by Days"
            render={(record: any) => {
              let days: string = "";

              if (record.period === null) {
                if (record.isMonday) {
                  days = days + " Monday,";
                }
                if (record.isTuesday) {
                  days = days + " Tuesday,";
                }
                if (record.isWednesday) {
                  days = days + " Wednesday,";
                }
                if (record.isThursday) {
                  days = days + " Thursday,";
                }
                if (record.isFriday) {
                  days = days + " Friday,";
                }
                if (record.isSaturday) {
                  days = days + " Saturday,";
                }
                if (record.isSunday) {
                  days = days + " Sunday,";
                }

                return days.replace(/,(?=[^,]*$)/, "");
              } else {
                return "-";
              }
            }}
          />
          <FunctionField
            label="Not Taking by Dates"
            render={(record: any) => {
              const format = "DD / MM / YYYY";
              return (
                <>
                  <Typography variant="body2">
                    {record.period === null
                      ? `-`
                      : `${moment
                          .utc(record.period?.start)
                          .format(format)} - ${moment
                          .utc(record.period?.end)
                          .format(format)}`}
                  </Typography>
                </>
              );
            }}
          />
        </Datagrid>
      </List>
    </>
  );
};

export default NotTakingList;
